import aeonikRegularUrl from "./Aeonik-Regular.woff2"
import aeonikBoldUrl from "./Aeonik-Bold.woff2"

// The URLs the build emits for two of the Aeonik faces `src/css/aeonik.css` already loads — the
// same hashed files, so the repo keeps a single copy of the font. (The Stripe iframe may still
// download them once for itself: Chrome caches content embedded from another site separately.)
//
// `@internal/consumer` takes them through its host props. Its Stripe card forms render inside an
// iframe on js.stripe.com that can't see this page's @font-face rules, so the face has to reach
// Stripe as font files, and the package never reaches into the host for files of its own.
export const AEONIK_FONT_URLS = { regular: aeonikRegularUrl, bold: aeonikBoldUrl }
